import script from "./CompanyEditView.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyEditView.vue?vue&type=script&setup=true&lang=js"

import "./CompanyEditView.vue?vue&type=style&index=0&id=966d6fc6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-966d6fc6"]])

export default __exports__